import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as editionsActions from './../editionsActions';

class EditionsSelector extends Component{

    onClickPrevEdition = () => {

        const isLoading = this.props.isEditionCurrentlyLoading;
        if(!isLoading){
            if(typeof this.props.previousEdition!=='undefined' && this.props.previousEdition.length>0){
                const targetEdition = this.props.previousEdition[0].publication_date;
                this.props.onPreviousEditionClicked(targetEdition);
            }
        }
    }

    onClickNextEdition = () => {
        const isLoading = this.props.isEditionCurrentlyLoading;
        if(!isLoading){
            if(typeof this.props.nextEdition!=='undefined' && this.props.nextEdition.length>0){
        
                const targetEdition = this.props.nextEdition[0].publication_date;
                this.props.onNextEditionClicked(targetEdition); 
            }
        }
    }

    render(){

        let editionTitle = '';  
     
        if(typeof this.props.currentEdition !=='undefined'){
            if(this.props.currentEdition.name){
                editionTitle = this.props.currentEdition.name;
            }
        }

        return(
           <div className="editionSelector">
             <span onClick={this.onClickPrevEdition} className="prev-btn">&lt;</span>
                <div className="current-name">{editionTitle}</div>   
             <span onClick={this.onClickNextEdition} className="next-btn">&gt;</span>
           </div> 
        )

    }

}

const mapStateToProps = state => {
    return {
        user: state.user,
        currentEdition : state.editions.current,
        nextEdition: state.editions.next,
        previousEdition: state.editions.previous,
        isEditionCurrentlyLoading : state.editions.specificEditionRetrievalInProgress
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onPreviousEditionClicked: (targetDate) => dispatch(editionsActions.getSpecificEditionByDate(targetDate, -1)), 
        onNextEditionClicked: (targetDate) => dispatch(editionsActions.getSpecificEditionByDate(targetDate, 1)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditionsSelector);


// WEBPACK FOOTER //
// ./src/components/Editions/Selector/EditionsSelector.js